import { useMutation } from '@apollo/react-hooks'
import { CREATE_CONTACT_MUTATION } from 'apollo'
import { ComponentType, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { Form } from './form'
import { Thanks } from './thanks'

const Wrapper = styled.div`
  padding-bottom: 20px;

  ${up('sm')} {
    padding-bottom: 120px;
  }
`

const Inner = styled.div`
  padding: 30px 0;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.regalBlue};

  ${up('sm')} {
    padding: 90px 0;
  }
`

export const Contact: ComponentType = () => {
  const [showThanks, setShowThanks] = useState(false)

  const [create, { loading }] = useMutation(CREATE_CONTACT_MUTATION, {
    onCompleted: () => setShowThanks(true),
  })

  return (
    <Container>
      <Row>
        <Col>
          <Wrapper>
            <Inner>
              <Container fluid>
                <Row className="justify-content-center">
                  <Col sm={showThanks ? 10 : 6}>
                    {showThanks ? (
                      <Thanks />
                    ) : (
                      <Form loading={loading} onSubmit={input => create({ variables: { input } })} />
                    )}
                  </Col>
                </Row>
              </Container>
            </Inner>
          </Wrapper>
        </Col>
      </Row>
    </Container>
  )
}
